<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
  {{ modalData.title}}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button *ngIf="modalData.value.CONSULT_STATUS === 'joined'">
      <img src="../../../../assets/direct-download-white.png" style="width: 20px;" (click)="downloadExcelByDateTime()">
    </button>
    <button mat-icon-button *ngIf="modalData.isEdit && modalData.value.CONSULT_STATUS !== 'joined'">
      <img src="../../../../assets/delete.png" style="width: 20px;" (click)="delete(consultForm.value)">
    </button>
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography" [style]="modalData.customStyle">
  <!-- {{modalData|json}} -->
  <div *ngIf="!modalData.isEdit">
    <!-- create -->
    <form [formGroup]="consultForm" class="mt-1">
      <div class="form-group row">
        <label for="type" class="col-4 col-form-label text-md-right">รูปแบบ</label>
        <div class="col-6">
          <select class="custom-select form-control" id="name" formControlName="type">
            <option value="ส่วนตัว">ส่วนตัว</option>
            <option value="ร่วมกับผู้อื่น">ร่วมกับผู้อื่น</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="date" class="col-4 col-form-label text-md-right">วันที่</label>
        <div *ngIf="date" class="col-6 col-form-label" id="date"> {{ date | date:'full' }} </div>
      </div>
      <div class="form-group row">
        <label for="time" class="col-4 col-form-label text-md-right">เวลา</label>
        <span *ngIf="time" class="col-6 col-form-label" id="time"> {{ time }} </span>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label text-md-right">รับคำปรึกษา</label>
        <div class="col-6 col-form-label">
          <mat-radio-group formControlName="solution">
            <mat-radio-button value="on-site" style="margin-right: 15px;">On Site</mat-radio-button>
            <mat-radio-button value="zoom">Online</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="consultForm.value.type === 'ร่วมกับผู้อื่น'" class="form-group row">
        <label for="max" class="col-4 col-form-label text-md-right">Max</label>
        <div class="col-6">
          <input type="number" class="form-control" id="max" formControlName="max" min="1" style="width: 100%;">
        </div>
      </div>
      <div class="form-group row">
        <label for="object" class="col-12 col-form-label text-center">หัวข้อ/รายละเอียด (ถ้ามี)</label>
        <div class="col-12">
          <textarea class="form-control" id="object" rows="3" style="width: 100%;" formControlName="object"></textarea>
        </div>
      </div>
    </form>

    <!-- see detail in calenda after joined -->
  </div>


  <!-- edit -->
  <div *ngIf="modalData.isEdit">
    <form *ngIf="modalData.isJoined" [formGroup]="consultForm" class="mt-1">
      <div class="form-group row">
        <label for="type" class="col-4 col-form-label text-md-right">รูปแบบ</label>
        <div class="col-6 col-form-label" id="date"> {{ modalData.value.CONSULT_TYPE }} </div>
      </div>
      <div class="form-group row">
        <label for="date" class="col-4 col-form-label text-md-right">วันที่</label>
        <div *ngIf="date" class="col-6 col-form-label" id="date"> {{ date | date:'full' }} </div>
      </div>
      <div class="form-group row">
        <label for="time" class="col-4 col-form-label text-md-right">เวลา</label>
        <span *ngIf="time" class="col-6 col-form-label" id="time"> {{ time }} </span>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label text-md-right">รับคำปรึกษา</label>
        <div class="col-6 col-form-label">
          <mat-radio-group formControlName="solution" [(ngModel)]="modalData.value.CONSULT_SOLUTION" disabled="true">
            <mat-radio-button value="on-site" style="margin-right: 15px;">On Site</mat-radio-button>
            <mat-radio-button value="zoom">Online</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="modalData.value.CONSULT_TYPE === 'ร่วมกับผู้อื่น'" class="form-group row">
        <label for="max" class="col-4 col-form-label text-md-right">จำนวนผู้เข้าร่วม</label>
        <div class="col-6">
          <span id="max" style="line-height: 2.7; float: left;">{{ modalData.value.CONSULT_REGISTER }} / &nbsp;</span>
          <input type="number" class="form-control" id="max" formControlName="max" min="1"
            style="width: 70%; float: left;" [(ngModel)]="modalData.value.CONSULT_MAX">
        </div>
      </div>

      <div *ngIf="modalData.value.CONSULT_TYPE === 'ส่วนตัว'" class="form-group row">
        <label for="max" class="col-4 col-form-label text-md-right">จำนวนผู้เข้าร่วม</label>
        <div class="col-6">
          <span id="max" style="line-height: 2.7; float: left;">{{ modalData.value.CONSULT_REGISTER }}</span>
        </div>
      </div>
      <div class="form-group row">
        <label for="object" class="col-12 col-form-label text-center">หัวข้อ/รายละเอียด (ถ้ามี)</label>
        <div class="col-12 mb-4">
          <textarea class="form-control" id="object" rows="3" style="width: 100%;"
            [value]="modalData.value.CONSULT_OBJECT" readonly></textarea>
        </div>
      </div>
    </form>

    <form *ngIf="!modalData.isJoined" [formGroup]="consultForm" class="mt-1">
      <div class="form-group row">
        <label for="type" class="col-4 col-form-label text-md-right">รูปแบบ</label>
        <div class="col-6">
          <select class="custom-select form-control" id="name" formControlName="type"
            [(ngModel)]="modalData.value.CONSULT_TYPE">
            <option value="ส่วนตัว">ส่วนตัว</option>
            <option value="ร่วมกับผู้อื่น">ร่วมกับผู้อื่น</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="date" class="col-4 col-form-label text-md-right">วันที่</label>
        <div *ngIf="date" class="col-6 col-form-label" id="date"> {{ date | date:'full' }} </div>
      </div>
      <div class="form-group row">
        <label for="time" class="col-4 col-form-label text-md-right">เวลา</label>
        <span *ngIf="time" class="col-6 col-form-label" id="time"> {{ time }} </span>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label text-md-right">รับคำปรึกษา</label>
        <div class="col-6 col-form-label">
          <mat-radio-group formControlName="solution" [(ngModel)]="modalData.value.CONSULT_SOLUTION">
            <mat-radio-button value="on-site" style="margin-right: 15px;">On Site</mat-radio-button>
            <mat-radio-button value="zoom">Online</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="modalData.value.CONSULT_TYPE === 'ร่วมกับผู้อื่น'" class="form-group row">
        <label for="max" class="col-4 col-form-label text-md-right">จำนวนผู้เข้าร่วม</label>
        <div class="col-6">
          <span id="max" style="line-height: 2.7; float: left;">
            {{ modalData.value.CONSULT_REGISTER ? modalData.value.CONSULT_REGISTER : 0 }} / &nbsp;
          </span>
          <input type="number" class="form-control" id="max" formControlName="max" min="1"
            style="width: 70%; float: left;" [(ngModel)]="modalData.value.CONSULT_MAX">
        </div>
      </div>
      <div class="form-group row">
        <label for="object" class="col-12 col-form-label text-center">หัวข้อ/รายละเอียด (ถ้ามี)</label>
        <div class="col-12">
          <textarea class="form-control" id="object" rows="3" style="width: 100%;" formControlName="object"
            [(ngModel)]="modalData.value.CONSULT_OBJECT"></textarea>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<div align="center" style="padding-bottom: 20px">
  <div *ngIf="!modalData.isEdit">
    <button mat-button *ngIf="consultForm.valid" (click)="create(consultForm.value)"
      style="background: #3E8C1A; color: #fff;">
      {{ modalData.actionBtnText }}
    </button>
    <button mat-button *ngIf="!consultForm.valid" [disabled]="!consultForm.valid">
      {{ modalData.actionBtnText }}
    </button>
  </div>
  <div *ngIf="modalData.isEdit">
    <div *ngIf="modalData.value.CONSULT_TYPE === 'ร่วมกับผู้อื่น'">
      <button mat-button (click)="edit(consultForm.value)" style="background: #3E8C1A; color: #fff;">
        {{ modalData.actionBtnText }}
      </button>
    </div>
    <div *ngIf="modalData.value.CONSULT_TYPE === 'ส่วนตัว'">
      <button *ngIf="modalData.value.CONSULT_REGISTER === 0 || !modalData.value.CONSULT_REGISTER" mat-button
        (click)="edit(consultForm.value)" style="background: #3E8C1A; color: #fff;">
        {{ modalData.actionBtnText }}
      </button>
    </div>
  </div>
</div>
